import { firestore } from "common/Firebase";
import { LoginStore } from "modules/login/LoginStore";
import { createUserModel, User } from "modules/login/models/User";
import * as firebase from "firebase";
import axios from "axios";
import Cookies from "js-cookie";

/**
 * Serive de autenticação.
 * @category Users
 * @hideconstructor
 */
class LoginService {
  async fetchUserByID(uid: string): Promise<User | undefined> {
    try {
      const userData = await firestore
        .collection("users")
        .doc(uid)
        .get()
        .then((doc) => doc.data());
      if (userData) {
        const user = createUserModel(userData);
        return user;
      }
      return undefined;
    } catch (e) {
      throw Error(`Fetch User Error: ${e}`);
    }
  }

  /**
   * Função para retornar um array de usuários
   * @param {string[]} userIDs
   */
  async fetchUsersByID(userIDs: string[]): Promise<User[]> {
    let users = new Array<User>();
    let size = 10;
    // Cria um batch de 10 elementos para não aparecer o erro "filters support a maximum of 10 elements"
    for (let userId of userIDs) {
      let checkUser = await LoginStore.checkUserAlreadyExistsInArray(userId);
      if (checkUser) {
        LoginStore.shareUsersObj.forEach((user) => {
          if (user.uid == userId) {
            users.push(user);
          }
        });
      } else {
        // Efetua a query pelos ids do laço de repetição
        const snap = await firestore
          .collection("users")
          .where("uid", "==", userId)
          .get();
        for (let doc of snap.docs) {
          let userData: any = doc.data();
          if (userData) {
            let user = createUserModel(userData);
            users.push(user);
            LoginStore.setShareUsersIDs(user.uid);
            LoginStore.setShareUsersObj(user);
          }
        }
      }
    }

    return users;
  }

  async FetchUserByEmail(email, authUser = true): Promise<any> {
    try {
      let data = await firestore
        .collection("users")
        .where("email", "==", email)
        .limit(1)
        .get();

      if (data.docs.length === 0) {
        if (authUser) {
          LoginStore.userAuth = undefined;
        }
        return null;
      }

      let userData = data.docs[0].data();
      if (userData) {
        let user = createUserModel(userData);

        if (authUser) {
          LoginStore.userAuth = user;
          LoginStore.isUserAuth = true;
        }
        return user;
      } else {
        if (authUser) {
          LoginStore.userAuth = undefined;
        }
      }
      return null;
    } catch (e) {
      throw Error(`Fetch User Error: ${e}`);
    }
  }

  async addUser(user: any): Promise<void> {
    try {
      await firestore
        .collection("users")
        .doc(user.uid)
        .set({ ...user, defaultLocation: [] });
    } catch (e) {
      throw Error(`AddUser Error: ${e}.`);
    }
  }

  /**
   * Atualiza a propriedade emailVerified do usuário para verdadeiro e
   * envia os do usuário verificado para a API de Marketing.
   * @param {User} user - Usuário a ser atualizado
   */
  async UpdateEmailVerified(user: User): Promise<void> {
    try {
      await firestore
        .collection("users")
        .doc(user.uid)
        .update({ emailVerified: true });

      let hubSpotInformations = {
        region: "na1",
        portalId: "20786608",
        formId: "b600b929-731b-4c6e-85c2-0a6226f06790",
        hapikey: "pat-na1-b9ef02a4-3db4-435e-8665-7f8bca4545ea",
      };

      let findUser = await firestore.collection("users").doc(user.uid).get();
      let data: any = {};
      let userObj: any = {};
      if (findUser) {
        data = findUser.data();
        userObj = {
          email: data.email,
          firstname: data.displayName,
          phone: data.phoneNumber,
          company: data.companyName,
          website: "",
          mega_tag: "FormTrialRubk",
          mega_cargo: data.jobTitle,
          mega_gclid: data.gclid,
          mega_utm_campaign: data.utm_campaign,
          mega_utm_keyword: data.utm_keyword,
          mega_utm_medium: data.utm_medium,
          mega_utm_source: data.utm_source,
        };
      }

      let fields: any = [];

      for (let i = 0; i < Object.keys(userObj).length; i++) {
        fields.push({
          objectTypeId: "0-1",
          name: Object.keys(userObj)[i],
          value: Object.values(userObj)[i],
        });
      }

      let millisecondsTimestamp = new Date().getTime();
      let format = {
        submittedAt: millisecondsTimestamp,
        fields: fields,
        context: {
          hutk: Cookies.get("hubspotutk"),
          pageUri: "www.rubk.app/register",
          pageName: "Rubk Trial",
        },
        legalConsentOptions: {
          consent: {
            consentToProcess: true,
            text: "I agree to allow Rubk to store and process my personal data.",
            communications: [
              {
                value: true,
                subscriptionTypeId: 999,
                text: "I agree to receive marketing communications from Rubk.",
              },
            ],
          },
        },
      };

      if (user.trial) {
        try {
          await axios.post(
            `https://api.hsforms.com/submissions/v3/integration/submit/${hubSpotInformations.portalId}/${hubSpotInformations.formId}/?hapikey=${hubSpotInformations.hapikey}`,
            format
          );
        } catch (error) {
          console.log(error);
        }
      }
    } catch (e) {
      throw Error(`UpdateEmailVerified Error: ${e}.`);
    }
  }

  async sendClickEventToHubspot(email: string) {
    if (!email) return;

    const fn = firebase.functions().httpsCallable("sendEventTrackToHubSpot");
    return fn({
      email,
    }).catch((error) => {
      console.error("Error on sendClickEventToHubspot", error);
    });

    // let user = await this.FetchUserByEmail(email);
    // this.UpdateEmailVerified(user);
    // return;
    // if (callback) {
    //   callback(user);
    // }
  }

  signOutUser = async (): Promise<boolean> => {
    try {
      await firebase
        .auth()
        .signOut()
        .catch((error) => {
          throw error;
        });
      return true;
    } catch (e) {
      throw e;
    }
  };

  getUserName = async (uid: string): Promise<string> => {
    let doc = await firestore.collection("users").doc(uid).get();
    let user = doc.data();
    if (user) return user.displayName;
    return "";
  };

  getUserEmail = async (uid: string): Promise<string> => {
    let doc = await firestore.collection("users").doc(uid).get();
    let user = doc.data();
    if (user) return user.email;
    return "";
  };

  /**
   * Atualiza a propriedade firstLogin para falso.
   * @param {User} user - Usuário a ser atualizado
   */
  async changeFirstLogin(user: User) {
    try {
      await firestore
        .collection("users")
        .doc(user.uid)
        .update({ firstLogin: false });
    } catch (e) {
      throw Error(`firstLogin Error: ${e}.`);
    }
  }

  /**
   * Atualiza a propriedade showTutorial.
   * @param {User} user - Usuário a ser atualizado
   * @param {boolean} value - Valor para showTutorial
   */
  async changeShowTutorial(user: User, value: boolean) {
    try {
      await firestore
        .collection("users")
        .doc(user.uid)
        .update({ showTutorial: value });
    } catch (e) {
      throw Error(`showTutorial Error: ${e}.`);
    }
  }
}

const service = new LoginService();
export { service as LoginService };



// WEBPACK FOOTER //
// ./src/modules/login/LoginService.ts